import { fork, call, put, all, takeEvery } from "redux-saga/effects";
import asyncInterface from "../../asyncInterface";
import * as actionTypes from './actionTypes'

function fetchAccountData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.carousel.fetchAccountData(fetchPayload);
}
function* fetchCarouselDataWorker(fetchPayload) {
  yield put({
    type: actionTypes.carouselDataLoaderType,
    payload: ""
  });
  try {
    const response = yield call(fetchAccountData, fetchPayload.payload.metaData);
    yield put({
      type:actionTypes.carouselDataSuccessType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: actionTypes.carouselDataFailedType,
      error
    });
  }
}

function* fetchCarouselDataWatcher() {
  yield takeEvery(actionTypes.carouselDataType, fetchCarouselDataWorker);
}

export default function* commonSagaWatcher() {
  yield all([fork(fetchCarouselDataWatcher)]);
}
